const languages = {
  en: "English",
  de: "Deutsch",
  es: "Español",
  fa: "فارسی",
  fr: "Français",
  hi: "हिंदी",
  id: "Bahasa",
  it: "Italiano",
  ja: "日本語",
  ko: "한국어",
  nl: "Nederlands",
  th: "ภาษาไทย",
  zh: "简体中文",
  tw: "繁體中文",
  vi: "Tiếng Việt"
};

export default languages;
